import { UserProfile } from 'fitbeat.gym-core';
import { IHeartRate } from 'fitbeat.models';
import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import { ScrollView, StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import { maskIdentifierIfTigernova } from '../utils/BluetoothService';
import { Button, ButtonTypes } from '../../components';
import Theme, { ThemeType } from '../../theme';
import { HeartFitnessIcon } from '../../ui/components/Icons';
import FitnessOutline from '../../assets/images/fitness-outline.svg';
import { IAppStore } from '../reducer';
import {
  isRemovingHeartRateIdentifierSelector, latestConnectedAppHRSelector, liveHeartRateSelector,
} from '../selectors/heartRateMonitorSelectors';
import { themeStyleMapper } from './HeartRateMonitorSetup';
import { HomeWorkoutResponsiveLayout } from './HomeWorkoutResponsiveLayout';
import { defaultScale } from '../../utils/scaling';
import CurrentConnectedAppHeartRateBanner from './CurrentConnectedAppHeartRateBanner';

interface IProps {
    themeType: ThemeType;
    userProfile: UserProfile;
    liveHeartRate: number | null;
    isRemovingHeartRateIdentifier: boolean;
    latestConnectedAppHR: IHeartRate | null;
    t: (key: string) => string;
    removeDevice(): void;
    closeModal(): void;
    showFaq(): void;
}

export class HasHeartRateDevice extends PureComponent<IProps, {}> {

    public render() {
        const { t, closeModal, removeDevice,
            userProfile,
            themeType = ThemeType.light,
            liveHeartRate,
            latestConnectedAppHR,
            isRemovingHeartRateIdentifier,
            showFaq,
        } = this.props;
        const themeStyle = themeStyleMapper[themeType];
        return (
            <View style={styles.container}>
                <CurrentConnectedAppHeartRateBanner
                  latestConnectedAppHR={latestConnectedAppHR}
                  t={t}
                  themeType={themeType}
                  showFaq={showFaq}
                />
                <ScrollView contentContainerStyle={styles.contentContainerStyle}>
                    {isRemovingHeartRateIdentifier ?
                        <Text style={[styles.descriptionText, themeStyle.textColor2]}>
                            {t('removingDevice')}
                        </Text> :
                        <View style={styles.bpmContainer}>
                            <View style={styles.bpmIconContainer}>
                                <FitnessOutline width={defaultScale(65)} height={defaultScale(65)}
                                    color={themeStyle.iconColor2.color} />
                                <Text style={[styles.bpmText, themeStyle.textColor1]}>
                                    {liveHeartRate}
                                </Text>
                            </View>
                            <Text style={[styles.connectedText, themeStyle.textColor1]}>
                                {t('connected')}
                            </Text>
                            <Text style={[styles.hrIdText, themeStyle.textColor2]}>
                                {maskIdentifierIfTigernova(userProfile.heartRateMonitors?.home)}
                            </Text>
                        </View>
                    }
                </ScrollView>
                <View style={styles.footer}>
                    <HomeWorkoutResponsiveLayout
                        containerStyle={styles.responsiveLayoutContainer}>
                        <Button
                            title={t('removeDevice')}
                            onPress={removeDevice}
                            fontColor={Theme.PRIMARY}
                            buttonType={ButtonTypes.TRANSPARENT}
                            containerStyle={[styles.buttonContainer, styles.margin]}
                        />
                        <Button
                            title={'Continue'}
                            onPress={closeModal}
                            fontColor={themeType === ThemeType.light ? Theme.WHITE : Theme.BLACK}
                            buttonType={ButtonTypes.NORMAL}
                            containerStyle={styles.buttonContainer}
                        />
                    </HomeWorkoutResponsiveLayout>
                </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    responsiveLayoutContainer: {
        flex: 0,
        justifyContent: 'space-between',
    },
    buttonContainer: {
        flexDirection: 'column',
        flexGrow: 1,
    },
    contentContainerStyle: {
        flexGrow: 1,
        justifyContent: 'center',
    },
    bpmContainer: {
        paddingTop: defaultScale(34),
        paddingBottom: defaultScale(20),
    },
    bpmIconContainer: {
        paddingBottom: defaultScale(20),
        alignSelf: 'center',
        textAlign: 'center',
        flexDirection: 'row',
    },
    bpmText: {
        fontSize: 40,
        marginLeft: defaultScale(5),
        alignSelf: 'center',
    },
    footer: {
        justifyContent: 'flex-end',
    },
    connectedText: {
        ...Theme.textStyle.heading,
        alignSelf: 'center',
        marginBottom: defaultScale(10),
    },
    hrIdText: {
        ...Theme.textStyle.bodyCopyReg,
        alignSelf: 'center',
    },
    margin: {
        marginBottom: defaultScale(10),
    },
    descriptionText: {
        ...Theme.textStyle.bodyCopyBold,
        marginHorizontal: defaultScale(22),
        marginBottom: defaultScale(4),
        alignSelf: 'center',
        textAlign: 'center',
    },
});

const mapStateToProps = (state: IAppStore) => ({
    liveHeartRate: liveHeartRateSelector(state),
    isRemovingHeartRateIdentifier: isRemovingHeartRateIdentifierSelector(state),
    latestConnectedAppHR: latestConnectedAppHRSelector(state),
});

const mapDispatchToProps = (dispatch: any, ownProps: IProps) => {
    return {};
};

export default translate(['heartRateDevice'])(connect(mapStateToProps, mapDispatchToProps)(HasHeartRateDevice));
